var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeontology(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: ""
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.178 42.2399C31.4838 77.0387 38.0888 89.4741 59.5552 96.3237C81.0419 89.4741 87.647 77.0183 87.9324 42.2399H80.2061C71.2363 42.2399 63.4285 37.1231 59.5552 29.6414C55.6819 37.1231 47.8741 42.2399 38.9043 42.2399H31.178ZM59.5552 101.726L58.8009 101.502C30.913 92.8989 26 74.7147 26 39.6509V37.0619H38.9043C48.873 37.0619 56.9662 28.9483 56.9662 19H62.1238C62.1238 28.9687 70.2374 37.0619 80.1857 37.0619H93.09V39.6509C93.09 74.7147 88.177 92.8989 60.2891 101.481L59.5348 101.706L59.5552 101.726Z",
    fill: "#8F72B1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeontology);
export default __webpack_public_path__ + "static/media/deontology.fc15ac4b463d79926ffaeba36ba1c179.svg";
export { ForwardRef as ReactComponent };